var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { "padding-bottom": "60px" },
      attrs: { gutter: 16, loading: _vm.loading },
    },
    [
      _c(
        "el-col",
        { attrs: { lg: 13, md: 24, xl: 13 } },
        [
          _c(
            "el-card",
            { staticClass: "card" },
            [
              _c(
                "div",
                {
                  staticClass: "card-title",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("store::album::edit_基本信息")) + " "
                  ),
                ]
              ),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("store::album::list_店铺"),
                        prop: "shopId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            popperAppendToBody: false,
                            placeholder: _vm.$t(
                              "system::common::select_placeholder"
                            ),
                          },
                          on: { change: _vm.changeShop },
                          model: {
                            value: _vm.form.shopId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shopId", $$v)
                            },
                            expression: "form.shopId",
                          },
                        },
                        _vm._l(_vm.shopList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("store::album::list_专辑类型") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.changeType },
                          model: {
                            value: _vm.form.dataType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dataType", $$v)
                            },
                            expression: "form.dataType",
                          },
                        },
                        [
                          _c("div", { staticClass: "form-radio" }, [
                            _c(
                              "div",
                              { staticStyle: { "margin-bottom": "24px" } },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("store::album::list_自动")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("span", { staticClass: "tip" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$t("store::album::edit_自动tip")
                                      ) +
                                      ")"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("store::album::list_手动")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("span", { staticClass: "tip" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$t("store::album::edit_手动tip")
                                      ) +
                                      ")"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("store::album::edit_专辑图片") } },
                    [
                      _c("pictureUpload", {
                        staticStyle: { display: "inline-block" },
                        attrs: { folder: "album" },
                        model: {
                          value: _vm.form.collectionImage,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "collectionImage", $$v)
                          },
                          expression: "form.collectionImage",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "tip",
                          staticStyle: {
                            "vertical-align": "bottom",
                            "line-height": "1",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("store::album::edit_推荐尺寸")) +
                              "：600*1080px "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("store::album::edit_图片描述") } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          "show-word-limit": "",
                          maxlength: 320,
                          placeholder: _vm.$t("store::album::edit_图片描述tip"),
                        },
                        model: {
                          value: _vm.form.collectionImageDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "collectionImageDesc", $$v)
                          },
                          expression: "form.collectionImageDesc",
                        },
                      }),
                      _c(
                        "span",
                        { staticStyle: { color: "#999", "font-size": "13px" } },
                        [_vm._v(_vm._s(_vm.$t("store::album::edit_图片tip")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("store::album::edit_标题"),
                        prop: "title",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { "show-word-limit": "", maxlength: 70 },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("store::album::edit_专辑描述") } },
                    [
                      _c("rich-editor", {
                        attrs: { height: 420 },
                        model: {
                          value: _vm.form.collectionDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "collectionDesc", $$v)
                          },
                          expression: "form.collectionDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { lg: 11, md: 24, xl: 11 } },
        [
          _c(
            "el-card",
            { staticClass: "card" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("store::album::edit_商品列表")) + " "
                    ),
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("store::album::edit_已选商品")) +
                          "：" +
                          _vm._s(_vm.form.customSortList.length || 0) +
                          " "
                      ),
                    ]),
                  ]),
                  _vm.form.dataType === 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: !_vm.form.conditions.length },
                              on: { click: _vm.getConditionGoods },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("store::album::edit_刷新列表")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.showConditionsDialog = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("store::album::edit_设置商品条件")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.form.shopId,
                          },
                          on: {
                            click: function ($event) {
                              _vm.showAddGoodsDialog = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("store::album::edit_添加商品")) +
                              " "
                          ),
                        ]
                      ),
                ],
                1
              ),
              _c(
                "el-input",
                {
                  attrs: {
                    placeholder: _vm.$t(
                      "store::album::edit_请输入商品名称或SPU搜索"
                    ),
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append",
                  }),
                ],
                1
              ),
              _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "list",
                    attrs: {
                      list: _vm.form.customSortList,
                      disabled: _vm.search.length,
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                _vm._l(_vm.showGoodsList, function (i) {
                  return _c(
                    "div",
                    { key: i.spuId, staticClass: "column-item" },
                    [
                      _c("i", {
                        staticClass: "iconfont iconSort drag-icon icon move",
                        attrs: { title: "移动" },
                      }),
                      _c("ZImg", {
                        staticClass: "images",
                        attrs: { src: i.spuImg },
                      }),
                      _c("div", { staticClass: "content" }, [
                        _c("div", [_vm._v(_vm._s(i.spuId))]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#999999",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(_vm._s(i.title))]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { lg: 11, md: 24, xl: 11 } },
        [
          _c("el-card", { staticClass: "card" }, [
            _c(
              "div",
              {
                staticClass: "card-title",
                attrs: { slot: "header" },
                slot: "header",
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("store::album::edit_商品专辑角标")) + " "
                ),
              ]
            ),
            _c("div", [
              _c("div", { staticClass: "coner-mark" }, [
                _c("span", [_vm._v("Sale：")]),
                _c(
                  "div",
                  {
                    staticClass: "mark",
                    class: _vm.form.tag === 2 ? "select" : "",
                    on: {
                      click: function ($event) {
                        _vm.form.tag = 2
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "mark-image",
                      attrs: { src: require("@/assets/images/album/half.png") },
                    }),
                    _vm.form.tag === 2
                      ? _c("div", { staticClass: "select-icon" }, [
                          _c("i", {
                            staticClass: "iconfont iconarrow-gouxuan",
                          }),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "coner-mark",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("span", [_vm._v("New：")]),
                  _c(
                    "div",
                    {
                      staticClass: "mark",
                      class: _vm.form.tag === 3 ? "select" : "",
                      on: {
                        click: function ($event) {
                          _vm.form.tag = 3
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "mark-image",
                        attrs: {
                          src: require("@/assets/images/album/new.png"),
                        },
                      }),
                      _vm.form.tag === 3
                        ? _c("div", { staticClass: "select-icon" }, [
                            _c("i", {
                              staticClass: "iconfont iconarrow-gouxuan",
                            }),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _c(
            "footer-fixed",
            [
              _c(
                "el-button",
                {
                  staticClass: "f-btn",
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("system::common::btn::cancel")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "f-btn",
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.sumbitLoading,
                  },
                  on: { click: _vm.confirm },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("system::common::btn::confirm")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("addGoods", {
        attrs: { goodsList: _vm.form.customSortList, shopId: _vm.form.shopId },
        on: { addGoods: _vm.addGoods },
        model: {
          value: _vm.showAddGoodsDialog,
          callback: function ($$v) {
            _vm.showAddGoodsDialog = $$v
          },
          expression: "showAddGoodsDialog",
        },
      }),
      _c("setCondition", {
        attrs: { form: _vm.form },
        on: { save: _vm.setAlbumCondition },
        model: {
          value: _vm.showConditionsDialog,
          callback: function ($$v) {
            _vm.showConditionsDialog = $$v
          },
          expression: "showConditionsDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }